/*!

=========================================================
* Material Kit PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { compose } from "recompose";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid, { GridProps } from "@material-ui/core/Grid";
import { WithStyles } from "@material-ui/styles";
const style = {
  grid: {
    marginRight: "-15px",
    marginLeft: "-15px",
    width: "auto"
  }
};

type GridContainerProps = Omit<GridProps, "ref">;

type Props = WithStyles<typeof style> & GridContainerProps;

const GridContainer: React.SFC<Props> = ({ ...props }) => {
  const { classes, children, className, ...rest } = props;
  return (
    <Grid container {...rest} className={classes.grid + " " + className}>
      {children}
    </Grid>
  );
};
GridContainer.defaultProps = {
  className: ""
};
export default compose<Props, GridContainerProps>(withStyles(style))(
  GridContainer
);
